import { fetchImask } from '../dynamic-modules';

type MaskInstance = { destroy: () => void };

const masks = new WeakMap<HTMLInputElement, MaskInstance>();

type MaskedWithUnmasked = { unmaskedValue: string };

type DynamicMaskedArg = {
    value: string;
    reset: () => unknown;
    compiledMasks: { resolve: (v: string) => unknown }[];
};

/**
 * Российская «8» в начале набора — дублирует уже зафиксированное в маске +7; не вставляем её.
 * Вставка «8» + 10 цифр (как с клавиатуры набрали 8-9XX…) → только 10 цифр НЗН.
 * Вставка «+7» + «8» + 10 цифр → убираем лишнюю 8 после кода страны.
 */
function prepareRuTelChunk(chunk: string, masked: MaskedWithUnmasked): string {
    const currentDigits = masked.unmaskedValue.replace(/\D/g, '');
    const national = currentDigits.startsWith('7') ? currentDigits.slice(1) : currentDigits;
    if (national.length > 0) return chunk;

    const incomingDigits = chunk.replace(/\D/g, '');
    if (/^8\d{10}$/.test(incomingDigits)) return incomingDigits.slice(1);
    if (/^78\d{10}$/.test(incomingDigits)) return `7${incomingDigits.slice(2)}`;
    if (chunk === '8') return '';

    return chunk;
}

export async function initTelMasks(container: Element | Document = document) {
    const { default: IMask } = await fetchImask();

    container.querySelectorAll<HTMLInputElement>('input[type="tel"]').forEach((input) => {
        if (masks.has(input)) return;

        const mask = IMask(input, {
            mask: '+{7} (000) 000-00-00',
            lazy: true,
            placeholderChar: '',
            prepare: prepareRuTelChunk,
            dispatch(appended: string, dynamicMasked: DynamicMaskedArg) {
                const value = dynamicMasked.value + appended;
                if (value.length <= 1) return dynamicMasked.reset();
                return dynamicMasked.compiledMasks[0].resolve(value);
            },
        });

        masks.set(input, mask);
    });
}

export function destroyTelMasks(container: Element | Document = document) {
    container.querySelectorAll<HTMLInputElement>('input[type="tel"]').forEach((input) => {
        const m = masks.get(input);
        if (m) {
            m.destroy();
            masks.delete(input);
        }
    });
}
